<div class="advanced-settings">
  <div class="content">

    <div class="content__title">Contributions</div>
    <div class="content__box">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Type</th>
              <th>Message</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let quest of quest.data">
              <td>{{ quest.type }}</td>
              <td>{{ quest.message }}</td>
              <td>
                <span [class.badge-grey]="quest.status == 0" [class.badge-purple]="quest.status == 1">{{ quest.status
                  == 1 ? 'Completed' : 'In Progress' }}</span>
              </td>
              <td>{{ quest.updatedAt | date:'short' }}</td>
            </tr>
            <tr *ngIf="!quest.data || quest.data.length === 0">
              <td colspan="4" class="text-center">No contributions found.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav *ngIf="quest.totalPages > 1" aria-label="Quest pagination" class="mt-3">
        <ul class="pagination justify-content-center mb-0">
          <li class="page-item" [class.disabled]="quest.page === 1">
            <button class="page-link" (click)="initQuest({page: quest.page - 1})"
              [disabled]="quest.page === 1">&laquo;</button>
          </li>
          <li class="page-item" *ngFor="let p of [].constructor(quest.totalPages); let i = index"
            [class.active]="quest.page === (i + 1)">
            <button class="page-link" (click)="initQuest({page: i + 1})">{{ i + 1 }}</button>
          </li>
          <li class="page-item" [class.disabled]="quest.page === quest.totalPages">
            <button class="page-link" (click)="initQuest({page: quest.page + 1})"
              [disabled]="quest.page === quest.totalPages">&raquo;</button>
          </li>
        </ul>
      </nav>
    </div>
    <div class="content__box">
      <div class="row">
        <div class="col-md-4 mb-2">
          <div class="stats-card d-flex align-items-center p-3 h-100"
            style="background: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.04);">
            <div class="stats-icon mr-3" style="font-size: 2.5rem; color: #28a745;">
              <i class="fa-solid fa-thumbs-up"></i>
            </div>
            <div>
              <div class="stats-title" style="font-weight: 600; font-size: 1.1rem;">Likes</div>
              <div class="stats-value" style="font-size: 1.7rem;">
                {{ questStats?.likes || 0 }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="stats-card d-flex align-items-center p-3 h-100"
            style="background: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.04);">
            <div class="stats-icon mr-3" style="font-size: 2.5rem; color: #dc3545;">
              <i class="fa-solid fa-flag"></i>
            </div>
            <div>
              <div class="stats-title" style="font-weight: 600; font-size: 1.1rem;">Reports</div>
              <div class="stats-value" style="font-size: 1.7rem;">
                {{ questStats?.reports || 0 }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="stats-card d-flex align-items-center p-3 h-100"
            style="background: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.04);">
            <div class="stats-icon mr-3" style="font-size: 2.5rem; color: #ffc107;">
              <i class="fa-solid fa-lightbulb"></i>
            </div>
            <div>
              <div class="stats-title" style="font-weight: 600; font-size: 1.1rem;">Suggestions</div>
              <div class="stats-value" style="font-size: 1.7rem;">
                {{ questStats?.suggest || 0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>